import * as Types from '../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetJobDescriptionQueryVariables = Types.Exact<{
    jobKeys: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;

export type GetJobDescriptionQuery = {
    __typename?: 'Query';
    jobData: {
        __typename?: 'JobDataPayload';
        results: Array<{
            __typename?: 'JobDataResult';
            job: {
                __typename?: 'Job';
                key: string;
                title: string;
                expired: boolean;
                employer?:
                    | { __typename?: 'Employer'; name?: string | null | undefined }
                    | null
                    | undefined;
                location: {
                    __typename?: 'JobLocation';
                    city?: string | null | undefined;
                    countryName?: string | null | undefined;
                    formatted: { __typename?: 'FormattedJobLocation'; short: string };
                };
            };
        }>;
    };
};

export type JobBasicInfoFragment = {
    __typename?: 'Job';
    key: string;
    title: string;
    expired: boolean;
    employer?: { __typename?: 'Employer'; name?: string | null | undefined } | null | undefined;
    location: {
        __typename?: 'JobLocation';
        city?: string | null | undefined;
        countryName?: string | null | undefined;
        formatted: { __typename?: 'FormattedJobLocation'; short: string };
    };
};

export const JobBasicInfoFragmentDoc = gql`
    fragment JobBasicInfo on Job {
        key
        title
        employer {
            name
        }
        location {
            formatted {
                short
            }
            city
            countryName
        }
        expired
    }
`;
export const GetJobDescriptionDocument = gql`
    query GetJobDescription($jobKeys: [ID!]!) {
        jobData(jobKeys: $jobKeys) {
            results {
                job {
                    key
                    title
                    employer {
                        name
                    }
                    location {
                        formatted {
                            short
                        }
                        city
                        countryName
                    }
                    expired
                }
            }
        }
    }
`;

/**
 * __useGetJobDescriptionQuery__
 *
 * To run a query within a React component, call `useGetJobDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobDescriptionQuery({
 *   variables: {
 *      jobKeys: // value for 'jobKeys'
 *   },
 * });
 */
export function useGetJobDescriptionQuery(
    baseOptions: Apollo.QueryHookOptions<GetJobDescriptionQuery, GetJobDescriptionQueryVariables> &
        ({ variables: GetJobDescriptionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetJobDescriptionQuery, GetJobDescriptionQueryVariables>(
        GetJobDescriptionDocument,
        options,
    );
}
export function useGetJobDescriptionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetJobDescriptionQuery,
        GetJobDescriptionQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetJobDescriptionQuery, GetJobDescriptionQueryVariables>(
        GetJobDescriptionDocument,
        options,
    );
}
export function useGetJobDescriptionSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetJobDescriptionQuery, GetJobDescriptionQueryVariables>,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetJobDescriptionQuery, GetJobDescriptionQueryVariables>(
        GetJobDescriptionDocument,
        options,
    );
}
export type GetJobDescriptionQueryHookResult = ReturnType<typeof useGetJobDescriptionQuery>;
export type GetJobDescriptionLazyQueryHookResult = ReturnType<typeof useGetJobDescriptionLazyQuery>;
export type GetJobDescriptionSuspenseQueryHookResult = ReturnType<
    typeof useGetJobDescriptionSuspenseQuery
>;
export type GetJobDescriptionQueryResult = Apollo.QueryResult<
    GetJobDescriptionQuery,
    GetJobDescriptionQueryVariables
>;
